import { render } from "./ToastComponent.vue?vue&type=template&id=c1794496&scoped=true"
import script from "./ToastComponent.vue?vue&type=script&lang=js"
export * from "./ToastComponent.vue?vue&type=script&lang=js"

import "./ToastComponent.vue?vue&type=style&index=0&id=c1794496&scoped=true&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1794496"]])

export default __exports__